<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn
        small
        outlined 
        color="red"
        v-on="on"
      >
        <span class="red--text">Cancel</span>
      </v-btn>
    </template>
    
    <v-card>
      <v-card-text> Are you sure you want to cancel this promise with {{ promise.promiser.user.name }} ?</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      promise: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.promises().cancel(this.promise.id)
          .then(response => {
            if (response.status === 200) {
              this.$emit('cancelled')
              this.$snack({ message: response.data.message })
            }
          })
          .catch(() => {})
          .then(() => {
            this.menu = false
            this.progressing = false
          })    
      },
    },
  }
</script>
